import { Link, useParams } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { articles } from '@/mocks/articles';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ArticleCard from '@/components/base/ArticleCard';
import TrendingSidebar from '@/pages/home/components/TrendingSidebar';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);
  const filtered = articles.filter((a) => a.categorySlug === slug);

  return (
    <>
      <Navbar />
      <main>
        {/* Breadcrumb */}
        <nav className="w-full bg-background-100 border-b border-background-200/70" aria-label="面包屑导航">
          <div className="w-full px-4 md:px-6 py-3">
            <ol className="flex items-center gap-2 text-sm text-foreground-600">
              <li>
                <Link to="/" className="hover:text-primary-600 transition-colors">首页</Link>
              </li>
              <li>
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-s-line text-xs text-foreground-400" />
                </div>
              </li>
              <li className="text-foreground-900 font-medium" aria-current="page">
                {category?.name || '分类'}
              </li>
            </ol>
          </div>
        </nav>

        {/* Category Header */}
        <section className="w-full bg-gradient-to-r from-primary-500/10 to-accent-500/10 border-b border-background-200/70">
          <div className="w-full px-4 md:px-6 py-10 md:py-14">
            <div className="max-w-4xl">
              <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 mb-3">
                {category?.name || '分类'}
              </h1>
              <p className="text-base text-foreground-600 leading-relaxed">
                {category?.description || '浏览该分类下的最新爆料内容'}
              </p>
            </div>
          </div>
        </section>

        {/* Content */}
        <div className="w-full px-4 md:px-6">
          <div className="flex flex-col lg:flex-row gap-8 py-10 md:py-14">
            <div className="flex-1 min-w-0">
              <div className="flex items-center justify-between mb-6">
                <p className="text-sm text-foreground-600">
                  共找到 <span className="font-semibold text-foreground-900">{filtered.length}</span> 篇文章
                </p>
              </div>
              {filtered.length > 0 ? (
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                  {filtered.map((article) => (
                    <ArticleCard key={article.id} article={article} />
                  ))}
                </div>
              ) : (
                <div className="text-center py-16">
                  <div className="w-16 h-16 mx-auto flex items-center justify-center mb-4 bg-background-100 rounded-full">
                    <i className="ri-inbox-line text-2xl text-foreground-400" />
                  </div>
                  <p className="text-foreground-500">该分类暂无文章</p>
                  <Link
                    to="/"
                    className="inline-block mt-3 text-sm text-primary-600 hover:text-primary-700 font-medium"
                  >
                    返回首页
                  </Link>
                </div>
              )}
            </div>
            <div className="w-full lg:w-[340px] shrink-0">
              <div className="lg:sticky lg:top-20">
                <TrendingSidebar />
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              {
                '@type': 'ListItem',
                position: 1,
                name: '首页',
                item: 'https://chiguaheiliaozx.com/',
              },
              {
                '@type': 'ListItem',
                position: 2,
                name: category?.name || '分类',
                item: `https://chiguaheiliaozx.com/category/${slug}`,
              },
            ],
          }),
        }}
      />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: `${category?.name || '分类'} - 吃瓜黑料在线`,
            description: category?.description || '',
            url: `https://chiguaheiliaozx.com/category/${slug}`,
            isPartOf: {
              '@type': 'WebSite',
              name: '吃瓜黑料在线',
            },
          }),
        }}
      />
    </>
  );
}